import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast"; // Import toast for notifications
import { IoIosArrowBack, IoMdShare } from "react-icons/io";
import ScrollTop from "../components/ScrollTop";
import PopupMenu from "../components/PopupMenu";
import { get_all_blogs } from "../store/reducers/homeReducer";
import { format } from "date-fns";

const BlogDetails = () => {
  const { slug } = useParams(); // Get the slug from the URL
  const navigate = useNavigate(); // Get the navigate function
  const dispatch = useDispatch();
  const { allBlogs } = useSelector((state) => state.home);
  useEffect(() => {
    dispatch(get_all_blogs());
  }, [dispatch]);
  const blog = allBlogs.find((b) => b.slug === slug); // Find the blog by slug

  // Handle case if blog is not found
  if (!blog) {
    return <div>Blog not found!</div>;
  }

  // Function to copy the blog link to the clipboard
  const handleShare = () => {
    const blogLink = `${window.location.origin}/blog/${blog.slug}`;
    navigator.clipboard
      .writeText(blogLink)
      .then(() => {
        toast.success("Link copied successfully"); // Show success message
      })
      .catch((err) => {
        toast.error("Failed to copy link"); // Show error message if failed
      });
  };

  return (
    <section
      className="h-auto mt-[-50px]  bg-cover bg-no-repeat relative bg-left"
      style={{
        backgroundImage: `url(${blog.image})`,
      }}
    >
      <div
        className=" left-0 top-0 w-full pt-10 pb-10 h-full bg-[#2422228a]"
        style={{ backdropFilter: "blur(8px)" }}
      >
        <div
          className="w-[85%] sm:w-[95%] mx-auto mt-10 p-10 sm:p-4 bg-slate-200/90 rounded-3xl"
          style={{ backdropFilter: "blur(8px)" }}
        >
          {/* Navigation Bar */}
          <div className="flex justify-between items-center mb-4">
            <button
              className="round-btn"
              onClick={() => navigate(-1)} // Go back to the previous page
            >
              <IoIosArrowBack />
            </button>
            <button
              className="round-btn"
              onClick={handleShare} // Share button to copy link
            >
              <IoMdShare />
            </button>
          </div>

          {/* Blog Content */}
          <div className="flex flex-col items-center px-5 sm:px-3">
            <div className="flex lg:block mb-5 ">
              <img
                className="w-[50%] lg:w-full h-[400px] sm:h-[250px] object-cover rounded-2xl "
                src={blog.image}
                alt={blog.name}
              />
              <div className="w-[50%] lg:w-full flex flex-col justify-center items-center px-5 sm:px-0">
                <h1 className="text-3xl sm:text-xl text-center font-bold mt-4">
                  {blog.name}
                </h1>
                <h1 className="text-xl sm:text-sm text-gray-600 text-center font-bold my-3">
                  {blog.subTitle}
                </h1>

                <p className="text-sm text-gray-500 mb-4">
                  By {blog.writtenBy}
                </p>
              </div>
            </div>

            <div className="text-right p-5 sm:p-0">
              {blog.description.split(".").map((paragraph, index) => (
                <p key={index}>{paragraph.trim()}.</p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ScrollTop />
      <PopupMenu />
    </section>
  );
};

export default BlogDetails;
